export const IS_LIVE_ENV = () => process.env.ENV === 'production';
export const IS_LIVE_STAGE = () => process.env.ENV === 'production' || process.env.ENV === 'stage';
